import classNames from 'classnames';
import useCombineRef from 'hooks/useCombineRef';
import { CSSProperties, useEffect, useRef } from 'react';
import { RegisterOptions, useFormContext, useWatch } from 'react-hook-form';
import styles from 'styles/components/common/forms/AutoHeightTextarea.module.scss';

type TProps = {
  name: string;
  rule?: RegisterOptions;
  placeholder?: string;
  textareaStyle?: CSSProperties;
  readOnly?: boolean;
  maxLength?: number;
};

const FormAutoHeightTextarea = ({
  name,
  rule,
  placeholder,
  textareaStyle,
  readOnly,
  maxLength,
}: TProps) => {
  const textareaRef = useRef<HTMLTextAreaElement>(null);
  const { register } = useFormContext();
  const { ref, ...rest } = register(name, rule);

  const textRef = useCombineRef<HTMLTextAreaElement>(ref, textareaRef);

  const handleChange = (event: React.KeyboardEvent<HTMLTextAreaElement>) => {
    const element = event.currentTarget;
    element.style.height = 'auto';
    element.style.height = element.scrollHeight + 'px';
  };

  const textareaValue = useWatch({
    name,
  });

  useEffect(() => {
    const textarea = textareaRef.current;
    if (textarea) {
      textarea.style.height = 'auto';
      textarea.style.height = textarea.scrollHeight + 'px';
    }
  }, [textareaRef, textareaValue]);

  return (
    <textarea
      {...rest}
      ref={textRef}
      style={{
        height: 'auto',
        ...textareaStyle,
      }}
      rows={1}
      onKeyDown={(event) => {
        handleChange(event);
      }}
      placeholder={placeholder}
      className={classNames(styles.textarea)}
      readOnly={readOnly}
      maxLength={maxLength}
    />
  );
};

export default FormAutoHeightTextarea;
